import { AfterViewInit, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AppCoreService } from 'src/app/services/app-core.service';
import { EditViewDeleteActionsRenderer } from '../../shared/ag-grid/cell-renderers/delete-view.component';
import { EditDeleteActionsRenderer } from '../../shared/ag-grid/cell-renderers/edit-delete.component';
import { Utilities } from 'src/app/models/utilities';
import Swal from 'sweetalert2';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { HttpHeaders } from '@angular/common/http';
import { CustomerService } from 'src/app/services/customer.service';
import { DiscountService } from 'src/app/services/system-config/discount/discount.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DiscountPeriodComponent } from './period/period.component';
import { DiscountDetailsComponent } from './details/details.component';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss']
})
export class DiscountComponent implements AfterViewInit {
  isFormSubmitted: boolean;
  discountForm: FormGroup;
  showBands = false;
  selectedFile: File | null = null;
  customerList: any[] = [];
  showAccordingDiscountOnInvoice = false;
  showAccordingDiscountOnAmount = false;
  showAccordingDiscountOnWeight = false;
  isCategoryVisible = false;
  isCustomerVisible = false;
  showProgressBar = false;
  progress = 0;
  discountId: number // DiscountPeriod table serial id 

  discountTypeList = ['Tariff', 'Bands', 'Contract'];
  categoryList = ['Discount on Invoice', 'Discount on Amount', 'Discount on Weight'];
  bandsList = ['Band 1', 'Band 2', 'Band 3', 'Band 4', 'Band 5', 'Band 6', 'Band 7', 'Band 8', 'Band 9', 'Band 10'];

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };

  public context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120
  };

  gridOptionsPeriod: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }

  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }

  currentDate: any;
  discountInfoData: any[] = [];
  discountPeriodData: any[] = [];

  columnDefsPeriod = [
    { headerName: 'Discount Type', field: 'type' },
    { headerName: 'Category', field: 'category' },
    { headerName: 'Customer', field: 'customer' },
    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'Band', field: 'band' },
    {
      headerName: 'Fuel', field: 'isfuelapplied', filter: true,
      cellRenderer: params => {
        let statusHtml = '<span class="badge  bg-warning">No</span>';
        if (params.data.isfuelapplied) {
          statusHtml = '<span class="badge bg-success">Yes</span>';
        }
        return statusHtml;
      },
    },
    {
      headerName: 'Freight', field: 'isfreightapplied', filter: true,
      cellRenderer: params => {
        let statusHtml = '<span class="badge  bg-warning">No</span>';
        if (params.data.isfreightapplied) {
          statusHtml = '<span class="badge bg-success">Yes</span>';
        }
        return statusHtml;
      },
    },
    {
      headerName: 'Other Charges', field: 'isotherchargesapplied', filter: true,
      cellRenderer: params => {
        let statusHtml = '<span class="badge  bg-warning">No</span>';
        if (params.data.isotherchargesapplied) {
          statusHtml = '<span class="badge bg-success">Yes</span>';
        }
        return statusHtml;
      },
    },
    {
      headerName: 'Volumetric Weight', field: 'isvolumetricweightapplied', filter: true,
      cellRenderer: params => {
        let statusHtml = '<span class="badge  bg-warning">No</span>';
        if (params.data.isvolumetricweightapplied) {
          statusHtml = '<span class="badge bg-success">Yes</span>';
        }
        return statusHtml;
      },
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
    },
  ];

  columnDefs = [
    { headerName: 'Vendor', field: 'vendor' },
    { headerName: 'Service', field: 'service' },
    { headerName: 'Calculation By', field: 'calculationby' },
    { headerName: 'Amount', field: 'amount' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      filter: false,
      sortable: false,
      minWidth: 100,
      pinned: 'right'
    },
  ];
  useEnterKey: any;

  constructor(
    private appCoreService: AppCoreService,
    private formBuilder: FormBuilder,
    private utilities: Utilities,
    private fileHandlerService: FileHandlerService,
    private customerService: CustomerService,
    private discountService: DiscountService,
    private ngxLoaderService: NgxUiLoaderService,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    private titleService: Title
  ) {
    titleService.setTitle('Discount');
    this.context = { componentParent: this, actionConfig: { update: true } };
  }

  ngOnInit(): void {
    this.currentDate = this.utilities.FormatDateWithTime();
    this.discountForm = this.formBuilder.group({
      ddlDiscountType: [null, Validators.required],
      ddlCategoryType: [null, Validators.required],
      ddlBands: [null, Validators.required],
      ddlCustomer: [null, Validators.required],

      txtFromDate: [this.currentDate.dateString, Validators.required],
      txtToDate: [this.currentDate.dateString, Validators.required],
      fileControl: [null, Validators.required],

      switchFuel: [false],
      switchFreight: [false],
      switchOtherCharges: [false],
      switchVolumetricWeight: [false],
    });

    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.getAllCustomers();
      this.getAllPeriodInfo();
    }
  }


  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.discountForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Discount');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  getAllCustomers() {
    try {
      // console.log("sc: ", this.appCoreService.GetUserData().selectedServiceCenter)
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
        if (res) {
          this.customerList = res.data;
          // console.log("customelist", res.data)
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  onChangeDiscountType() {
    const discountType = this.discountForm.get('ddlDiscountType').value;

    this.showBands = false;
    this.isCategoryVisible = false;
    this.isCustomerVisible = false;

    this.discountForm.controls.ddlBands.clearValidators();
    this.discountForm.controls.ddlCategoryType.clearValidators();
    this.discountForm.controls.ddlCustomer.clearValidators();

    if (discountType === 'Tariff') {
    }
    else if (discountType === 'Bands') {
      this.showBands = true;
      this.discountForm.controls.ddlBands.addValidators(Validators.required);
    }
    else if (discountType === 'Contract') {
      this.isCategoryVisible = true;
      this.isCustomerVisible = true;
      this.discountForm.controls.ddlCategoryType.addValidators(Validators.required);
      this.discountForm.controls.ddlCustomer.addValidators(Validators.required);
    }
    this.discountForm.controls.ddlBands.updateValueAndValidity();
    this.discountForm.controls.ddlCategoryType.updateValueAndValidity();
    this.discountForm.controls.ddlCustomer.updateValueAndValidity();
  }

  onChangeCategory() {
    const categoryType = this.discountForm.get('ddlCategoryType').value;

    this.showAccordingDiscountOnAmount = false;
    this.showAccordingDiscountOnWeight = false;

    if (categoryType === 'Discount on Amount') {
      this.showAccordingDiscountOnAmount = true;
    } else if (categoryType === 'Discount on Weight') {
      this.showAccordingDiscountOnWeight = true;
    }
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.selectedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  uploadDiscount() {
    this.isFormSubmitted = true;
    let interval: any;
    let timeout: any;

    try {
      if (this.discountForm.valid) {
        if (this.selectedFile) {

          clearInterval(interval);
          clearTimeout(timeout);

          this.showProgressBar = true;
          this.progress = 0;
          interval = setInterval(() => {
            if (this.progress < 99) {
              this.progress += 1;
            }
          }, 100);
          timeout = setTimeout(() => {
            if (this.progress >= 99 && this.progress < 100) {
              this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
              this.showProgressBar = false;
              clearInterval(interval);
            }
          }, 5000);

          this.ngxLoaderService.start();
          let isDiscountPeriodValid = false;

          let dataObj = {
            fromdate: this.discountForm.get('txtFromDate').value,
            todate: this.discountForm.get('txtToDate').value,
            discounttype: this.discountForm.get('ddlDiscountType').value,
          };
          // console.log("dataObj: ", dataObj);

          this.discountService.checkDiscountPeriod(dataObj).subscribe(res => {
            try {
              if (res && res.success) {
                isDiscountPeriodValid = res.data?.id;
                if (!isDiscountPeriodValid) {
                  let reqObj = {
                    name: this.selectedFile.name,
                    fileType: this.selectedFile.type,
                    category: this.discountForm.get('ddlDiscountType').value,
                  }
                  // console.log("reqObj: ", reqObj);

                  this.fileHandlerService.GetSignedURLForUpload(reqObj).subscribe(res => {
                    try {
                      if (res && res.success) {
                        // console.log(" get signed url for upload success ", res.data)
                        const signedURL = res.data.uploadURL;
                        const fileId = res.data.fileId;
                        // console.log("signedURL", signedURL)
                        // console.log("fileId", fileId)
                        if (signedURL) {
                          let headers: HttpHeaders = new HttpHeaders({
                            "Content-Type": reqObj.fileType
                          });
                          this.fileHandlerService.UploadFile(signedURL, this.selectedFile, headers).subscribe((f) => {
                            if (f === null) {
                              this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                                if (res && res.success) {
                                  // console.log(" Upload Complete : ", res);
                                  //logic to  insert period data to the table
                                  this.processDiscount(fileId);
                                  this.stopProgressBar(interval, timeout);
                                  this.activeModal.close('import succesfull');
                                }
                                else if (res && !res.success) {
                                  console.error('Upload complete failed:', res);
                                  this.stopProgressBar(interval, timeout);
                                  this.ngxLoaderService.stop();
                                }
                              });
                            } else {
                              console.error('File upload failed:', f);
                              this.stopProgressBar(interval, timeout);
                              this.ngxLoaderService.stop();
                            }
                          });
                        }
                        else {
                          console.error('No signed URL returned.');
                          this.stopProgressBar(interval, timeout);
                          this.ngxLoaderService.stop();
                        }
                      }
                      else if (res && !res.success) {
                        console.error('Failed to obtain signed URL:', res);
                        this.stopProgressBar(interval, timeout);
                        this.ngxLoaderService.stop();
                      }
                    } catch (error) {
                      console.error('Error during file upload process:', error);
                      this.stopProgressBar(interval, timeout);
                      this.ngxLoaderService.stop();
                    }
                  });
                }
                else {
                  this.isFormSubmitted = false;
                  let msg = `An active discount period for type - <b>${this.discountForm.get('ddlDiscountType').value}</b>
                              is already available. Please update the date range and try uploading again.`;
                  this.invalidPeriodDialog(msg);
                  this.stopProgressBar(interval, timeout);
                  this.ngxLoaderService.stop();
                }
              }
            }
            catch (error) {
              console.error(error);
            }
          });
        } else {
          this.openErrorDialog(" No File Selected !");
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  processDiscount(fileId) {
    const reqObj = {
      fileid: fileId,
      discounttype: this.discountForm.get('ddlDiscountType')?.value,
      categorytype: this.discountForm.get('ddlCategoryType')?.value,
      band: this.discountForm.get('ddlBands')?.value,
      customerid: this.discountForm.get('ddlCustomer')?.value,
      fromdate: this.discountForm.get('txtFromDate')?.value,
      todate: this.discountForm.get('txtToDate')?.value,
      isfuelapplied: this.discountForm.get('switchFuel')?.value,
      isfreightapplied: this.discountForm.get('switchFreight')?.value,
      isotherchargesapplied: this.discountForm.get('switchOtherCharges')?.value,
      isvolumetricweightapplied: this.discountForm.get('switchVolumetricWeight')?.value,
    }

    this.discountService.uploadDiscount(reqObj).subscribe(res => {
      if (res && res.success) {
        // console.log(" PeriodInfo  Added Successfully : ",res)
        this.successDialog("Record Added successfully");
        this.getAllPeriodInfo();
      }
    })
  }

  getAllPeriodInfo() {
    this.ngxLoaderService.start();
    this.discountService.getAllPeriodInfo().subscribe(res => {
      try {
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.discountPeriodData = res.data;
          // console.log(res.data);
        } else {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })
  }

  getDiscountInfo(discountPeriodId: any) {
    this.ngxLoaderService.start();
    this.discountService.getDiscountInfoByPeriod(discountPeriodId).subscribe(res => {
      try {
        if (res && res.data) {
          this.ngxLoaderService.stop();
          this.discountInfoData = res.data;
          // console.log(" Info Data  :", res.data);
        } else {
          this.ngxLoaderService.stop();
        }
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    })
  }

  viewAction(cell: any) {
    if (cell) {
      this.discountId = cell.id;
      this.getDiscountInfo(this.discountId);
    }
  }

  editPeriodAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        this.openDiscountPeriodModal(cell);
      }
    } catch (e) {
      console.error(e);
    }
  }

  openDiscountPeriodModal(data) {
    const modalRef = this.modalService.open(DiscountPeriodComponent, this.ngbModalOptions);
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.discountTypes = this.discountTypeList;
    modalRef.result.then(
      (result) => {
        if (result) {
          this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          this.getAllPeriodInfo();
        }
      },
      (reason) => {
        if (reason == 'Cross click') {

        }
      }
    )
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        const discountDetailData = this.discountInfoData.find(item => item.id === cell.id);
        this.openPeriodDetailModal(discountDetailData);
      }
    } catch (e) {
      console.error(e);
    }
  }

  openPeriodDetailModal(data) {
    const modalRef = this.modalService.open(DiscountDetailsComponent, this.ngbModalOptions);
    modalRef.componentInstance.data = data;
    // console.log(" data openPeriodDetailModal: ", modalRef.componentInstance.data)
    modalRef.result.then(
      (result) => {
        if (result) {
          this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          this.getDiscountInfo(this.discountId);
        }
      },
      (reason) => {
        if (reason == 'Cross click') {

        }
      }
    );
  }

  async deletePeriodAction(cell: any) {
    if (cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed)
        this.discountService.DeleteDiscountPeriodById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.getAllPeriodInfo();
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }

  async deleteAction(cell: any) {
    if (cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed)
        this.discountService.Upload_Delete(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.getDiscountInfo(this.discountId);
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }

  stopProgressBar(interval: any, timeout: any) {
    new Promise<void>((resolve) => {
      setTimeout(() => {
        this.showProgressBar = false;
        resolve();
      }, 1000);
    }).then(() => {
      // console.log('period is not valid');
      this.isFormSubmitted = false;
      clearInterval(interval);
      clearTimeout(timeout);
    });
  }

  onGridReadyPeriod(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async openErrorDialog(msg: any) {
    await Swal.fire({
      // title: 'Error!',
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (success.isConfirmed) {
      // this.getAllRatePeriod();
      this.isFormSubmitted = false;
      this.discountForm.reset();
      this.discountForm.controls.txtFromDate.setValue(this.currentDate.dateString);
      this.discountForm.controls.txtToDate.setValue(this.currentDate.dateString);
    }
  }

  async openConfirmationDialog() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: "This action is irreversible. Are you sure you want to delete?",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  async invalidPeriodDialog(msg: string) {
    const result = await Swal.fire({
      titleText: 'Error',
      html: msg,
      icon: 'error',
      // confirmButtonText: 'Yes',
      // showDenyButton: true,
      // denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });

    if (result.isConfirmed) {
      return false;
    }
  }

  async warningDialog(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }


}